module.exports = __webpack_public_path__ + "static/media/IconAtendimento.b7e346e2.svg";